export default __webpack_public_path__ + "static/media/huisjes1Klein.4149fa14.jpg";